import { apiClient, getHeaders } from '@/services/axiosConfig'
export default {
  getEventSaleProducts (auth, payload) {
    return apiClient({
      method: 'get',
      url: `/v1/event-sale-products${payload.strParams ? `?${payload.strParams}` : ''}`,
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  },
  getOngoingSession (auth, payload) {
    return apiClient({
      method: 'post',
      url: '/v1/event-sale-sessions/ongoing',
      headers: {
        ...apiClient.defaults.headers,
        ...getHeaders(auth.loggedIn, auth.value)
      },
      ...payload
    })
  }
}
